export const typeInErrors = (errors, type) => {
  for (let err of errors) {
    if (err.type === type) {
      return true;
    }
  }
  return false;
};

export const getErrorTypeFromApi = (response) => {
  const { errors } = response?.data;
  const errorType = errors?.[0]?.type || 'UNKNOWN_ERROR';
  return errorType;
};
